/**
 * 个人设置中：
 *  姓名默认可见（编辑权限从接口中读，此处false仅占位）
 *  手机、邮箱默认可见可编辑
 *  其余字段默认不可见不可编辑
 */
export const DEFAULT_PERSONAL_FIELD_AUTH = {
    nickname: { visible: true, editable: false },
    phone: { visible: true, editable: true },
    email: { visible: true, editable: true }
};
